import * as React from 'react';

export function CourseRibbonBackgroundSVG(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width={40} height={40} rx={8} fill="#233B58" />
            <path
                d="M20.02 19.001a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                fill="#43B75D"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="m20.46 9.54 1.44-.47a1.4 1.4 0 0 1 1.69.7l.69 1.35c.137.267.354.484.62.62l1.35.69a1.4 1.4 0 0 1 .7 1.69l-.47 1.44a1.47 1.47 0 0 0 0 .88l.47 1.44a1.4 1.4 0 0 1-.7 1.69l-1.35.69a1.43 1.43 0 0 0-.62.62l-.69 1.35a1.4 1.4 0 0 1-1.69.7l-1.44-.47a1.47 1.47 0 0 0-.88 0l-1.44.47a1.4 1.4 0 0 1-1.69-.7l-.69-1.35a1.431 1.431 0 0 0-.62-.62l-1.35-.69a1.4 1.4 0 0 1-.7-1.69l.47-1.44a1.47 1.47 0 0 0 0-.88l-.47-1.44a1.4 1.4 0 0 1 .7-1.69l1.35-.69a1.43 1.43 0 0 0 .62-.62l.69-1.35a1.4 1.4 0 0 1 1.69-.7l1.44.47c.287.09.594.09.88 0v0Z"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="m20.06 22.74-3.21 8.28-1.95-3.95-4.9.51 5.64-6.56"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="m20 22.74 3.21 8.28 1.95-3.95 4.9.51-5.64-6.56"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function CourseRibbonBackgroundSVGNew({ iconColor = '#01AAB9' }: { iconColor?: string }) {
    return (
        <svg
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
                fill={iconColor}
            />
            <path
                d="M11.4998 1.50018L12.8998 1.00018C13.5998 0.800181 14.2998 1.10018 14.5998 1.70018L15.2998 3.00018C15.3998 3.30018 15.6998 3.50018 15.8998 3.60018L17.1998 4.30018C17.7998 4.60018 18.0998 5.30018 17.8998 6.00018L17.3998 7.40018C17.2998 7.70018 17.2998 8.00018 17.3998 8.30018L17.9998 9.90018C18.1998 10.6002 17.8998 11.3002 17.2998 11.6002L15.9998 12.3002C15.6998 12.4002 15.4998 12.7002 15.3998 12.9002L14.6998 14.2002C14.3998 14.8002 13.6998 15.1002 12.9998 14.9002L11.5998 14.4002C11.2998 14.3002 10.9998 14.3002 10.6998 14.4002L9.29979 14.9002C8.59979 15.1002 7.89979 14.8002 7.59979 14.2002L6.89979 12.9002C6.79979 12.6002 6.49979 12.4002 6.29979 12.3002L4.99979 11.6002C4.39979 11.3002 4.09979 10.6002 4.29979 9.90018L4.79979 8.50018C4.89979 8.20018 4.89979 7.90018 4.79979 7.60018L4.09979 6.10018C3.89979 5.50018 4.19979 4.70018 4.79979 4.40018L6.09979 3.70018C6.39979 3.60018 6.59979 3.30018 6.69979 3.10018L7.39979 1.80018C7.69979 1.20018 8.39979 0.900181 9.09979 1.10018L10.4998 1.60018C10.8998 1.60018 11.1998 1.60018 11.4998 1.50018Z"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.1 14.7L7.8 23L5.9 19.1L1 19.6L6.6 13"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 14.7L14.2 23L16.2 19.1L21.1 19.6L15.4 13"
                stroke="#0A2545"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function CourseRibbonSVG(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#prefix__clip0)">
                <path d="M12 11a3 3 0 100-6 3 3 0 000 6z" fill="#fff" />
                <path
                    d="M12.5 1.5l1.4-.5c.7-.2 1.4.1 1.7.7l.7 1.3c.1.3.4.5.6.6l1.3.7c.6.3.9 1 .7 1.7l-.5 1.4c-.1.3-.1.6 0 .9l.6 1.6c.2.7-.1 1.4-.7 1.7l-1.3.7c-.3.1-.5.4-.6.6l-.7 1.3c-.3.6-1 .9-1.7.7l-1.4-.5c-.3-.1-.6-.1-.9 0l-1.4.5c-.7.2-1.4-.1-1.7-.7l-.7-1.3c-.1-.3-.4-.5-.6-.6L6 11.6c-.6-.3-.9-1-.7-1.7l.5-1.4c.1-.3.1-.6 0-.9l-.7-1.5c-.2-.6.1-1.4.7-1.7l1.3-.7c.3-.1.5-.4.6-.6l.7-1.3c.3-.6 1-.9 1.7-.7l1.4.5c.4 0 .7 0 1-.1z"
                    stroke="#fff"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.1 14.7L8.8 23l-1.9-3.9-4.9.5L7.6 13"
                    stroke="#fff"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14.7l3.2 8.3 2-3.9 4.9.5-5.7-6.6"
                    stroke="#fff"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="prefix__clip0">
                    <path fill="#fff" transform="translate(1)" d="M0 0h22.1v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
